import {createHttp} from './http-factory'
// 新网关接口
let baseUrl = window.location.host=='utest.jr.jd.com' ? '//msinner.jr.jd.com/gw2/generic/activity/h5/m/' : '//ms.jr.jd.com/gw2/generic/activity/h5/m/'
export const Http = createHttp({baseURL: baseUrl}); // Domain A
